<template>
  <div>
    <SD :mode="1" :name="room" v-if="room && sensorcheck"  />
    <LD :room="room" :data="td" :sensor="sensor" v-if="td" :alertlist="alertlistdata" :nameLocation="initiallocation[0].value" :tree="initiallocation" :childlist="childlist"/>
    <link
      rel="stylesheet"
      href="https://use.fontawesome.com/releases/v5.5.0/css/all.css?v=6.4.2"
    />
    <vs-sidebar
      id="sdlo1"
      default-index="1"
      color="primary"
      class="sidebarx w3-hide-small w3-hide-medium"
      v-model="active"
      spacer
    >
      <vs-row class="mt-1 mb-1" style="display: flex; align-items: center">
        <vs-list-item icon="room" title="Location"> </vs-list-item>
        <vs-spacer />
        <vs-button
          class="hiddenDesktop cursor-pointer"
          color="danger"
          icon="close"
          size="large"
          @click="swap"
          type="flat"
        ></vs-button>
      </vs-row>

      <vs-button
        class="primary mt-2"
        to="/Overview"
        icon="reply"
        type="filled"
        id="btnbackover"
      >
        <h6>Back to Overview</h6>
      </vs-button>

      <!-- <vs-button class="hiddenDesktop cursor-pointer" color="danger" icon="close" size="large"  @click="swap"  type="flat"></vs-button> -->

      <vs-list class="mb-4">
        <!-- <vs-button  class="container-fluid" color="primary" size="small" to="/Overview" type="border" icon="reply">&nbsp;&nbsp;&nbsp;Back to Overview</vs-button> -->
      </vs-list>
      <br />
      <vs-row style="display: flex; align-items: center">
        <vs-button
          icon="keyboard_arrow_up"
          color="primary"
          @click="handleClick(false)"
          type="flat"
          ><h6 id="fontsi">Collapse All</h6></vs-button
        >
        <vs-spacer />
        <vs-button
          color="primary"
          @click="handleClick(true)"
          icon="expand_more"
          type="flat"
          ><h6 id="fontsi">Expand All</h6></vs-button
        >
      </vs-row>
      <h6 id="mapl" class="mb-3 mt-2 ml-1"><b>Location List</b></h6>
      <div
        style="width: 250px; height: 800px"
        ref="tree2"
        class="dhx-container--tree mt-2"
      ></div>
    </vs-sidebar>
    <!-- <div class="parentx-static">

    <vs-sidebar default-index="1" color="primary" class="sidebarx" spacer v-model="active2">

     <vs-list-item title="Location" >
      <vs-button class="hiddenDesktop cursor-pointer" color="danger" icon="close" size="large"  @click="swap"  type="flat"></vs-button>
    </vs-list-item>
    <vs-list class="mb-4" >
    <vs-button style="width: 100%;" color="primary" size="small" to="/Overview" type="border" icon="reply">&nbsp;&nbsp;&nbsp;Back to Overview</vs-button>
   
   
    
  </vs-list>
   <br>
    <vs-row  style="display: flex;
  align-items: center;">
      <vs-button  icon="keyboard_arrow_up" color="primary" @click="handleClick(false)" type="flat"><h6>Collapse All</h6></vs-button> <vs-spacer />
      <vs-button  color="primary" @click="handleClick(true)"  icon="expand_more" type="flat"><h6>Expand All</h6></vs-button>
     
    </vs-row>
    <hr>
    
    <div  align="center" ref="tree" class="dhx-container--tree"></div>

    </vs-sidebar>
  </div> -->
    <div id="myDIV">
      <h4>
        <vs-list-item class="hiddenDesktop" title="Location"></vs-list-item>
      </h4>
      <!-- <vs-row  style="display: flex;align-items: center;">
      <vs-button class=" hiddenDesktop" icon="keyboard_arrow_up" color="primary" @click="handleClick1(false)" type="flat"><h6>Collapse All</h6></vs-button> <vs-spacer />
      <vs-button class=" hiddenDesktop" color="primary" @click="handleClick1(true)"  icon="expand_more" type="flat"><h6>Expand All</h6></vs-button>
     
    </vs-row> -->
      <div
        align="left"
        ref="tree"
        class="dhx-container--tree mt-2 hiddenDesktop"
      ></div>
    </div>
    <div class="main-container-fluid"></div>
  </div>
</template>

<script>
import fromCDN from "from-cdn";
import { Tree as TreeDHX, TreeCollection } from "dhx-suite";
import LD from "../dashboard/Location/LocationDashboard.vue";
import SD from "../Page/SensorDashboard";
import SensorListVue from './SensorList.vue';
export default {
  name: "Location",
  components: {
    LD,
    SD,
  },
  data: () => ({
    sensorcheck: false,
    td: null,
    sensorlist: [],
    room: null,
    data: new TreeCollection(),
    data2: new TreeCollection(),
    events: [
      {
        name: null,
      },
    ],
    tree: null,
    tree2: null,
    show1: true,
    sensor: null,
    alertlist: [],
    childlist: [],
    treedata: {},
    active: true,
    active2: false,
    initiallocation: "",
    alertlistdata: [],
    username: '',
    admin: ''
  }),
  methods: {
    setChildData(child) {
      this.childlist = [];
      var temp = {};
      child.forEach((element, i) => {
        temp["id"] = i + 1;
        temp["name"] = element.value;
        if (element.sens[0]) {
          temp["sensor"] = element.sens;
        } else {
          temp["sensor"] = "-";
        }
        this.childlist.push(temp);
        temp = {};
      });
      console.log(this.childlist);
    },
    setAlertList(sensor) {
      var con = {}
      this.alertlistdata = []
      console.log('alert func')
      this.alertlist.forEach(element => {
        con = JSON.parse(element.con)
        sensor.forEach(Selement => {
          console.log(Selement.name, con)
          if(Selement.name == con.senname.name) 
            this.alertlistdata.push({name: element.alertname, con:element.alerthistory[0].message, sensor: Selement.name,
                                      time: element.alerthistory[element.alerthistory.length-1].timestamp,
                                      status: element.alertstatus})
        });
      })
    },

    findnameloop(loc, name) {
      var temp = [];
      loc.forEach((el) => {
        // console.log(el)
        if (el.value == name) {
          this.td = el;
          this.childlist = el.items;
          // // console.log(this.td)
          this.sensor = [];
          // this.alertlist = [];
          this.td.sens.forEach((element) => {
          this.sensor.push(this.sensorlist.find(sensor => sensor.serial_id == element))
            // console.log(temp)
            // this.$API
            //   .get(
            //       "sensor/user/serial-id/" +
            //       element
            //   )
            //   .then((result) => {
            //     this.sensor.push(result.data[0])
            //     temp.push(result.data[0])
            //     });
          })
          // console.log(this.sensor)
          // console.log(this.sensor)
        }
        if (el.items) {
          this.findnameloop(el.items, name);
        }
      });
    },

    callapi() {
      this.$API.post("hierarchy");
    },
    swap() {
      // console.log('test')
      this.active = !this.active;
    },
    handleClick1(value) {
      this.data.map((item) => {
        this.data.update(item.id, { opened: value });
      });
    },
    handleClick(value) {
      this.data2.map((item) => {
        this.data2.update(item.id, { opened: value });
      });
    },
  },
  mounted() {
    var queryId = this.$route.query.locid
    this.username = this.$session.get('Username')
    this.admin = this.$session.get('admin')
    // console.log(queryId)
    if(queryId != null) this.$vs.loading()
    this.$API
      .get("sensors/user")
      .then((result) => {
        this.sensorlist = result.data;
        console.log(this.sensorlist)
      });
    this.$API
      .get("alertlog/user")
      .then((result) => {
        this.alertlist = result.data
        console.log(this.alertlist)
    });
    const url = this.$url2 +"listview/" + (this.username = this.admin ? this.admin : this.username);
    // console.log(url)

    fromCDN([
      "https://cdn.dhtmlx.com/suite/edge/suite.js",
      "https://cdn.dhtmlx.com/suite/edge/suite.css",
    ]).then(() => {
      this.tree = new TreeDHX(this.$refs.tree, {
        data: this.data,
        css: "custom-class",
        icon: {
          file: "fas fa-folder",
        },
      });
      this.data.load(url).then(() => {
        this.initiallocation = this.tree.data.serialize();
      });
      this.tree.events.on("itemClick", (id) => {
        console.log('click!');
        const keyId = Math.random();
        this.events = [{ keyId, name: "Click", value: id }];
        this.sensorcheck = false;
        this.sensorlist.forEach((element) => {
          if (id == element.name) {
            this.sensorcheck = true;
          }
        });
        this.room = id;
        this.findnameloop(this.initiallocation, id);
        this.setAlertList(this.sensor);
      });
    });
    // setInterval(() => {
    //   this.data2 = new TreeCollection()
    //   if (this.tree2) {
    //     this.tree2.destructor();
    //   }
    // }, 1000);
    fromCDN([
      "https://cdn.dhtmlx.com/suite/edge/suite.js",
      "https://cdn.dhtmlx.com/suite/edge/suite.css",
    ]).then(() => {
      this.tree2 = new TreeDHX(this.$refs.tree2, {
        data: this.data2,
        css: "custom-class",
        icon: {
          file: "fas fa-folder",
        },
      });
      this.data2.load(url).then(() => {
        this.initiallocation = this.tree2.data.serialize();
      console.log(this.initiallocation)
      });
      this.tree2.events.on("itemClick", (id) => {
        console.log('click!');
        const keyId = Math.random();
        this.events = [{ keyId, name: "Click", value: id }];
        this.sensorcheck = false;
        this.sensorlist.forEach((element) => {
          if (id == element.name) {
            this.sensorcheck = true;
          }
        });
        this.room = id;
        this.findnameloop(this.initiallocation, id);
        setTimeout(() => {
          this.setAlertList(this.sensor)
          console.log('set alert!');
          // this.setChildData(this.childlist)
        }, 100);
      });
    });
    setTimeout(() => {
      if(queryId != null) {
        const keyId = Math.random();
        this.events = [{ keyId, name: "Click", value: queryId }];
        this.sensorcheck = false;
        this.sensorlist.forEach((element) => {
          if (queryId == element.name) {
            this.sensorcheck = true;
          }
        });
        this.room = queryId;
        this.findnameloop(this.initiallocation, queryId)
        this.data2.map((item) => {
          this.data2.update(item.id, { opened: true });
        });
          this.setAlertList(this.sensor)
          // this.setChildData(this.childlist)
      }
          this.$vs.loading.close()
    }, 1000);
  },
  beforeDestroy() {
    if (this.tree) {
      this.tree.destructor();
    }
  },
};
</script>
<style scoped>
.dhx_tree-list-item__text {
  padding-left: 2px;
  font-size: 0.75rem;
}
#fontsi {
  font-size: 0.75rem;
}
#btnbackover {
  margin: 0px 5px 0px 10px;
  border-radius: 30px;
  display: flex;
  width: 90%;
  background-color: #4caf50;
  align-items: center;
}
</style>

<style>
.custom-class {
  padding: 0px;
}
.custom-class .dhx_tree-list-item__text {
  color: #5cb85c;
  font-size: 0.75rem;
}
.custom-class .dhx_tree-folder .dhx_tree-list-item__text {
  color: #5cb85c;
  font-size: 0.75rem;
}
#lo {
  bottom: 7%;
  right: 7%;
}
#sdlo1 {
  display: show;
}
#mapl {
  font-weight: normal;
  color: #32c040;
}
</style>
